export default {"src":"/_next/static/media/government-banner.3cd51a4b.svg","height":700,"width":700,"blurWidth":0,"blurHeight":0};